<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="1300px">
      <template v-slot:activator="{ on, attrs }">
        <v-row>
          <v-col cols="12" class="d-flex">
            <v-btn text medium v-bind="attrs" v-on="on">
              <v-icon medium color="green lighten-1"> mdi-check-all </v-icon>
              Detalhes da Tranferência
            </v-btn>
          </v-col>
        </v-row>
      </template>
      <v-card>
        <v-toolbar dark dense color="red lighten-1" elevation="0">
          <v-col cols="11" class="d-flex justify-start">
            <v-toolbar-title>Detalhes da Transferencia</v-toolbar-title>
          </v-col>
          <v-col class="d-flex justify-end">
            <v-btn icon @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-row>
            <v-col cols="10">
              <v-row>
                <v-col cols="6">
                  <strong>Setor Destino</strong><br />
                  {{ selected_movement.reciever_entity }} -
                  {{ selected_movement.reciever_department }}
                </v-col>
                <v-col cols="6">
                  <strong>Solicitante da Tranferência</strong><br />
                  {{ selected_movement.user_name }}
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <strong>Tipo de Tranferência</strong><br />
                  {{ selected_movement.movement_type }}
                </v-col>
                <v-col cols="6">
                  <strong>Data da Tranferência</strong><br />
                  {{ selected_movement.movement_date }}
                </v-col>
              </v-row>
            </v-col>
            <v-col class="mt-5" cols="2">
              <v-row class=" d-flex justify-center">
              <v-btn fab dark large color="red lighten-1">
                <a
                  :href="base_url + '/uploaded_movement_document/' + selected_movement.id"
                  target="_blank"
                  style="text-decoration: none"
                  ><v-icon medium color="white lighten-1"> mdi-download </v-icon></a
                >
              </v-btn>
              </v-row>
              <v-row class="mt-2 px-2 d-flex justify-center">
                <strong> Download de Comprovante de Tranferência Assinado </strong>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-toolbar dark dense color="red lighten-1" elevation="0">
                <v-toolbar-title>Itens Transferidos</v-toolbar-title>
              </v-toolbar>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Nome</th>
                      <th class="text-left">Nº de Serie</th>
                      <th class="text-left">Nº de Tombo</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in related_assets" :key="item.id">
                      <td>{{ item.movemented_asset.item_description }}</td>
                      <td>{{ item.movemented_asset.serial_number }}</td>
                      <td>{{ item.movemented_asset.asset_number }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'TransferDetail',
  props: { movementId: Number },
  data: () => ({
    base_url: process.env.VUE_APP_BASE_URL,
    dialog: false,
    selected_movement: '',
    related_assets: '',
  }),
  computed: {
    ...mapState('movements', ['movements']),
  },
  created() {
    this.selected_movement = this.movements.find((movement) => {
      return movement.id == this.movementId
    })

    this.related_assets = [...this.selected_movement.movemented_assets]
  },
}
</script>
